import { Component, Inject, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { DOCUMENT } from '@angular/common';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import * as nations from '../../files/countries.json';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})

export class FormComponent implements OnInit {

  public showcase: any;
  public country: any;
  public city: any;
  public zip: any;
  public cityPopulation: any;
  public durationFrom: number;
  public durationTo: number;
  public title: any;
  public type: any;
  public keywords: any;
  public summary: any;
  public overview: any;
  public countries: any[];
  public implementationTitle: any;
  public implementationSummary: any;
  public implementationContent: any;

  public multiTitle: any;
  public multiSummary: any;
  public multiContent: any;

  public otherTitle: any;
  public otherSummary: any;
  public otherContent: any;

  public references: any;
  public learning: any;
  public Editor: ClassicEditor;
  public valid: boolean = false;

  public QuillConfiguration = {
    toolbar: {
      container:
        [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          ['clean'],
          ['link', 'image']
        ],
    },
  }
  public LinksQuillConfiguration = {
    toolbar: {
      container:
        [
          ['link'],
        ],
    },
  }

  public implementations: IAProto[] = [{
    content: ''
  }];

  public multis: MoaProto[] = [{
    content: ''
  }];

  public urlPattern: RegExp =  /^(https?:\/\/)[\w.-]+(\.[\w.-]+)+(:\d+)?(\/[^\s]*)?$/;


  constructor(private req: HttpRequestsService<any>, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.countries = nations.countries;
  }

  extractUrlFromReference(reference: string): string | null {
    const match = reference.match(/href="([^"]*)"/);
    if (match) {
      const url = match[1].trim();
      
      if (this.urlPattern.test(url)) {
        return url;
      }
    }

    const plainUrlMatch = reference.match(/(https?:\/\/[^\s<>"']+)/);
    if (plainUrlMatch) {
      const url = plainUrlMatch[1].trim();
      if (this.urlPattern.test(url)) {
        return url;
      }
    }
    return null;
  }

  processReferences(references: string): string[] {
    if (!references) {
      return [];
    }

    const rawReferences = references.split(/[\n,]+/);

    const uniqueUrls = new Set<string>();
    rawReferences.forEach(reference => {
      const url = this.extractUrlFromReference(reference);
      if (url) {
        uniqueUrls.add(url);
      }
    });

    return Array.from(uniqueUrls);
  }

  onSubmit() {
    let yearTodigits: any;
    let message: any = '';
    if (this.durationTo != undefined) {
      yearTodigits = this.durationTo.toString().length
    }
    if (this.zip == undefined) {
      if (message == '') {
        message = 'Zip code is required'
      }
      else {
        message = message + ', zip code is required'
      }
    }
    if (this.durationFrom == null || !Number.isInteger(Number(this.durationFrom)) || this.durationFrom.toString().length != 4) {
      if (message == '') {
        message = 'Starting date is required and needs to be valid year'
      }
      else {
        message = message + ', starting date needs to be a valid year'
      }
    }
    if (this.durationTo != undefined && (!Number.isInteger(Number(this.durationTo)) || yearTodigits != 4)) {
      if (message == '') {
        message = 'Ending date needs to be a valid year'
      }
      else {
        message = message + ', ending date needs to be a valid year'
      }
    }
    if ((this.durationFrom == null || !Number.isInteger(Number(this.durationFrom)) || this.durationFrom.toString().length != 4)
      || (this.zip == undefined)
    ) {
      Swal.fire(
        message,
        'Please correct your document and submit it again!',
        'error'
      )
      message = '';
    }

    let dataObj = {
      showcase: this.showcase ? this.showcase : '',
      country: this.countries.find((el) => el.code === this.country)?.name || '',
      countryCode: this.country ? this.country : '',
      city: this.city ? this.city : '',
      zipCode: this.zip ? this.zip.toString() : '',
      cityPopulation: this.cityPopulation ? this.cityPopulation.toString() : '',
      yearFrom: Number(this.durationFrom),
      yearTo: 0,
      type: this.type ? this.type : '',
      title: this.title ? this.title : '',
      keywords: this.keywords ? this.keywords.split(',') : [],
      summary: this.summary ? this.summary : '',
      overview: this.overview ? this.overview : '',
      implementationActivitySections: this.implementations ? this.implementations : [],
      multiObjectiveApproachSections: this.multis ? this.multis : [],
      otherSections: [],
      learning: [],
      references: this.references ? this.processReferences(this.references) : [],

    }
    if (this.zip != undefined && this.durationFrom != null && Number.isInteger(Number(this.durationFrom))
      && this.durationFrom.toString().length == 4 && (this.durationTo == undefined || yearTodigits == 4)) {
      this.req.postDocument(dataObj).subscribe(
        res => {
          Swal.fire(
            'Done!',
            'Your document was submitted successfully!',
            'success'
          )
          this.refreshPage();
        },
        error => {
          console.log(error)
        }
      )
    }
  }

  refreshPage() {
    window.scroll(0, 0);
    this.showcase = '';
    this.country = '';
    this.city = '';
    this.zip = '';
    this.cityPopulation = '';
    this.durationFrom = null;
    this.durationTo = null;
    this.type = '';
    this.title = '';
    this.keywords = '';
    this.summary = '';
    this.overview = '';
    this.implementations = [];
    this.multis = [];
    this.references = '';
  }

  addIA() {
    this.implementations.push(new IAProto());
  }

  addMoa() {
    this.multis.push(new MoaProto());
  }

}

export class IAProto {
  content: string;
}

export class MoaProto {
  content: string;
}





